export const environment = {
    production: false,
    appVersion: require('../../package.json').version,
    appTitle :"Digital Helpdesk for Ottobock by MVIP",
    appLogoPath : "assets\\ottobock_logo.svg",
    appFavicon : "assets\\faviconente.ico",
    appLogoFavicon : "assets\\favicondemo.ico",
    appFavicongif :"assets\\favicon1.gif",
    pCC_loginissue_Frontend: "https://digitalsupport-ottobock-by-mvip.de",
    tCCTicketFrontend: "https://support.digitalsupport-ottobock-by-mvip.de",
    tCCTicketServer: "https://ticket.digitalsupport-ottobock-by-mvip.de",
    TicketAuthorisation: "https://authorisation.digitalsupport-ottobock-by-mvip.de"

};
